import { useDispatch } from "react-redux";
import CustomPage from "components/CustomPage";
import { useEffect, useState } from "react";
import DatesReports from "components/CustomSearch";
import moment from "moment";
import Header from "./Header";
import NullCheck from "components/NullCheck";
import { Stack, Typography } from "@mui/material";
import http from "http";
import { DATE_FOR_API_FORMAT } from "config/const";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { apiUrl } from "config/settings";
import { setShowLoading } from "store/sysSlice";
import { findKeyByValue, groupBy, sortArray } from "config/functions";
import CustomDataGrid from "components/customDataGrid";
import { METER_TYPE } from "config/const";
import CustomTabs from "components/CustomTabs";

const MeterReadReport = () => {
  const dispatch = useDispatch();
  const { bt } = useBizTypeTranslation();
  const [datesReports, setDatesReports] = useState(true);
  const [list, setList] = useState([]);
  const [filterList, setFilterList] = useState([]);
  const [meters, setMeters] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);

  const TABS = [
    { title: 'ELECTRICITY' },
    { title: 'WATER' },
    { title: 'GAS' },
    { title: 'CHLORINE' },
  ]

  const callBackDate = async (data) => {
    if (data) {
      dispatch(setShowLoading(true));
      const dates = {
        start: moment(data?.startDate).startOf('day').format(DATE_FOR_API_FORMAT),
        end: moment(data?.endDate).endOf('day')?.format(DATE_FOR_API_FORMAT),
      };

      http
        .get(`${apiUrl}/reports/meterRead/${dates?.start}/${dates?.end}`)
        .then((res) => {
          dispatch(setShowLoading(false));

          // const groupByType = groupBy(res?.data?.data,"meter._id")
          // let MetersList = []
          // Object.keys(groupByType).forEach(key => {
          //   const maxMeterRead = getMaxItemByKey(groupByType[key], "readValue")
          //   const dailyAverage = sum(groupByType[key], "readValue") / groupByType[key]?.length
          //   MetersList.push({
          //     id: groupByType[key][0]?.meter?._id,
          //     name:groupByType[key][0]?.meter?.name,
          //     type: groupByType[key][0]?.meter?.type,
          //     maxMeterRead: maxMeterRead?.readValue,
          //     dailyAverage: dailyAverage
          //   })
          // }) 

          // setMeters(MetersList);
          setList(res?.data?.data);
          prepareList(res?.data?.data)
        });
    }
  };

  const prepareList = (listData) => {
    const listByType = groupBy(listData, "meter.type")
    let newList = []

    Object.keys(listByType)?.map(key => {
      let typeList = sortArray(listByType[key], "meter._id")

      typeList = typeList?.map((item, idx) => {
        const meter = item?.meter
        const lastItem = idx === 0 ? null : typeList[idx - 1]
        const isNewMeter = lastItem?.meter?._id !== meter?._id
        const lastReadValue = idx === 0 || isNewMeter ? "" : typeList[idx - 1]?.readValue
        const consumption = lastItem?.meter._id === meter?._id ? item?.readValue - lastReadValue : ""

        return (
          isNewMeter && idx !== 0
            ? { id: idx }
            : {
              id: item?._id,
              name: meter?.name,
              type: meter?.type,
              midPeakValue: item?.midPeakValue ? parseFloat(item?.midPeakValue).toFixed(2) : "",
              offPeakValue: item?.offPeakValue ? parseFloat(item?.offPeakValue).toFixed(2) : "",
              onPeakValue: item?.onPeakValue ? parseFloat(item?.onPeakValue).toFixed(2) : "",
              readValue: item?.readValue ? parseFloat(item?.readValue).toFixed(2) : "",
              lastReadValue: lastReadValue ? parseFloat(lastReadValue).toFixed(2) : "",
              consumption: consumption ? parseFloat(consumption).toFixed(2) : ""
            }
        )
      })
      newList.push(typeList)
    })

    setFilterList(newList);
  }

  return (
    <CustomPage hidePadding header={<Header setDatesReports={setDatesReports} list={list} />}>
      {/* <CustomTabs callBackFunc={(e) => setSelectedTab(e)} tabList={TABS}/> */}

      <NullCheck valueForCheck={list?.length > 0}>
        <Stack padding={1} spacing={2}>
          {Object.keys(filterList)?.map(key => {
            let typeList = filterList[key]
            return (
              <Stack padding={1} border='1px solid #000' spacing={2}>
                <Typography textAlign='center' fontWeight='bold' variant="h5">
                  {bt(findKeyByValue(METER_TYPE, typeList[0]?.type))}
                </Typography>

                <CustomDataGrid
                  pageSize={10}
                  columns={[
                    {
                      field: "name",
                      headerName: bt("METER_NAME"),
                      width: 250,
                      filterable: false,
                    },
                    {
                      field: "midPeakValue",
                      headerName: bt("MID_PEAK_VALUE"),
                      with: 50,
                      filterable: false,
                      renderCell: (value) => value?.row?.midPeakValue
                    },
                    {
                      field: "offPeakValue",
                      headerName: bt("OFF_PEAK_VALUE"),
                      with: 50,
                      filterable: false,
                      renderCell: (value) => value?.row?.offPeakValue
                    },
                    {
                      field: "onPeakValue",
                      headerName: bt("ON_PEAK_VALUE"),
                      with: 50,
                      filterable: false,
                      renderCell: (value) => value?.row?.onPeakValue
                    },
                    {
                      field: "readValue",
                      headerName: bt("READ_VALUE"),
                      with: 50,
                      filterable: false,
                      renderCell: (value) => value?.row?.readValue
                    },
                    {
                      field: "lastReadValue",
                      headerName: bt("LAST_READ_VALUE"),
                      with: 50,
                      filterable: false,
                      renderCell: (value) => value?.row?.lastReadValue
                    },
                    {
                      field: "consumption",
                      headerName: bt("CONSUMPTION"),
                      with: 50,
                      filterable: false,
                      renderCell: (value) => value?.row?.consumption
                    },
                  ]}
                  list={typeList}
                />
              </Stack>
            )
          })
          }
        </Stack>
      </NullCheck>

      <DatesReports
        btnTitle="CREATE_REPORT"
        title='DATES'
        open={datesReports}
        setOpen={setDatesReports}
        callBack={callBackDate}
      />
    </CustomPage>
  );
};
export default MeterReadReport;
